import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class PartyHat extends PositionedGoodyHOC {
	// 1
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st30: {
				fill: '#C8B8F2',
			},
			st1: {
				fill: '#A2D8C0',
			},
			st13: {
				fill: '#F2CC7B',
			},
			st11: {
				fill: '#FC7E7E',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="31.8727417" cy="91.439743" />
				<path style={style.st2} d="M66.7650146,86.2496185c-21.6400146,6.920166-44.9000244,6.920166-66.5300293,0L13.164917,52.8497162
					l2.6101074-6.7299805l1.0899658-2.8300781L33.4949951,0.3096782l16.6400146,42.9699707l0.8299561,2.1401367l2.5,6.4799805
					L66.7650146,86.2496185z" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.9746635 0.6556352)" style={style.st30} cx="10.7373371" cy="77.4687042" rx="3.6241295" ry="3.6241295" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.326685 1.2937791)" style={style.st1} cx="23.4465237" cy="65.2117081" rx="3.6241295" ry="3.6241295" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -4.0717745 1.8501824)" style={style.st13} cx="33.8727417" cy="79.9507217" rx="3.6241295" ry="3.6241295" />
				<path style={style.st11} d="M18.2850342,49.3697357c0.0999756,2-1.4300537,3.6999512-3.4300537,3.8100586
					c-0.5999756,0.0300293-1.1800537-0.0900879-1.6900635-0.3300781l2.6101074-6.7299805
					C17.164917,46.5596771,18.2049561,47.8196869,18.2850342,49.3697357z" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -1.7507921 1.3185166)" style={style.st30} cx="24.7145786" cy="34.6389046" rx="3.6241295" ry="3.6241295" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -2.5427375 1.8304178)" style={style.st13} cx="34.2536621" cy="50.2650528" rx="3.6241295" ry="3.6241295" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.2864468 2.3973894)" style={style.st11} cx="44.8856812" cy="64.9825668" rx="3.6241295" ry="3.6241295" />
				<path style={style.st1} d="M53.4649658,51.899765c-0.0400391,0.0100098-0.0799561,0.0100098-0.1199951,0.0100098
					c-2,0.0998535-3.6999512-1.4299316-3.8099365-3.4299316c-0.0600586-1.2402344,0.5100098-2.3701172,1.4299316-3.0600586
					L53.4649658,51.899765z" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.8894804 3.0455716)" style={style.st30} cx="57.1641846" cy="77.0104218" rx="3.6241295" ry="3.6241295" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -1.7152613 2.2394111)" style={style.st11} cx="42.6052055" cy="34.4097633" rx="3.6241295" ry="3.6241295" />
				<ellipse transform="matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -0.9181879 1.7705231)" style={style.st1} cx="33.903492" cy="18.705595" rx="3.6241295" ry="3.6241295" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/PartyHat.js